import { render, staticRenderFns } from "./RomaMessages.vue?vue&type=template&id=728988fa&scoped=true&"
import script from "./RomaMessages.vue?vue&type=script&lang=js&"
export * from "./RomaMessages.vue?vue&type=script&lang=js&"
import style0 from "./RomaMessages.vue?vue&type=style&index=0&id=728988fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728988fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
